import React from 'react';
import { withRouter } from 'react-router-dom';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import MediaQuery from 'react-responsive';
import { FormatHeader } from 'components/atoms/formatHeader';
import MobileHeader from 'components/atoms/mobileHeader';
import hamburgerIcon from 'assets/images/menuhamburger.png';
import hamburgerWhiteIcon from 'assets/images/Hamburger-Menu-v3_White-3.png';
import { useViewport } from 'components/templates/viewportProvider';
import './styles.scss';
import { RouteUtil } from 'utils/RouteUtil';

const Header = props => {
  const {
    type,
    theme,
    breadcrumbList,
    onMenuPress,
    showGetInTouch,
    headerButtons,
    textDecoration,
    toggleHeaderItem = false,
    headerArtistButton,
    closeRestaurantModal,
    campaignCode,
    salesEmail,
    projectInterested,
    roleName,
    showApplyNow,
  } = props;
  const icon =
    theme === 'light-theme' ? hamburgerWhiteIcon : hamburgerWhiteIcon;
  return (
    <>
      <MediaQuery maxDeviceWidth={575.98}>
        <MobileHeader
          type={type}
          icon={<img src={icon} alt={'icon'} />}
          onClick={() => onMenuPress(theme)}
          breadcrumbList={breadcrumbList}
          showGetInTouch={showGetInTouch}
          textDecoration={textDecoration}
          headerArtistButton={headerArtistButton}
          headerItem={toggleHeaderItem ? headerButtons : null}
          closeRestaurantModal={closeRestaurantModal}
          campaignCode={campaignCode}
          salesEmail={salesEmail}
          projectInterested={projectInterested}
          roleName={roleName}
          showApplyNow={showApplyNow}
        />
      </MediaQuery>
      <MediaQuery minDeviceWidth={576}>
        <Row className={`header-section`}>
          <Col xs={1} sm={1} md={1}>
            <Row>
              <Col xs={6} sm={6} md={6}>
                <a onClick={() => onMenuPress(theme)} className={'menu-icon'}>
                  <img src={hamburgerWhiteIcon} alt={'icon'} />
                </a>
              </Col>
            </Row>
          </Col>
          <Col xs={5} sm={5} md={5}>
            <Breadcrumb>
              {breadcrumbList.map((item, idx) => {
                if (idx === 0) {
                  return (
                    <Breadcrumb.Item
                      onClick={() =>
                        RouteUtil.setRouteChange(props, item.breadcrumbLink)
                      }
                      // href={item.breadcrumbLink}
                      key={item.breadcrumbName}
                    >
                      <FormatHeader breadcrumbText={item.breadcrumbName} />
                    </Breadcrumb.Item>
                  );
                } else {
                  return (
                    <Breadcrumb.Item
                      onClick={() =>
                        RouteUtil.setRouteChange(props, item.breadcrumbLink)
                      }
                      // href={item.breadcrumbLink}
                      key={item.breadcrumbName}
                    >
                      {item.breadcrumbName}
                    </Breadcrumb.Item>
                  );
                }
              })}
            </Breadcrumb>
          </Col>
          <Col xs={6} sm={6} md={6} className={'button-col'}>
            <div className={'header-buttons'}>{headerButtons}</div>
          </Col>
        </Row>
      </MediaQuery>
    </>
  );
};

export default withRouter(Header);
